import type { connexion as Fr } from '../fr/connexion';

/** « connexion » in English — typed on the French: a missing sentence does not compile. */
export const connexion: typeof Fr = {
  impossible: 'Unable to sign in',
  sousTitre: 'Vehicle rental — Agency management',
  accroche: 'Your rules are no longer just printed on the back of the agreement.',
  accrocheSuite: 'They are enforced.',
  titre: 'Sign in',
  identifiezVous: 'Sign in to access your workstation.',
  email: 'Email address',
  motDePasse: 'Password',
  envoi: 'Signing in…',
  seConnecter: 'Sign in',
  demonstration: 'Demo: the accounts created by “npm run mise-en-service”',
  serveur: (adresse) => `Server: ${adresse}`,
  memeOrigine: 'same origin',
  adresseServeur: 'Server address',
  adresseServeurAide: 'Paste the server address, then press Enter.',
};
